import { createAction } from "@reduxjs/toolkit";
import * as types from "../types/actions";
import { create } from "lodash";
export const payloadBE = createAction(types.ATHENA_VIR_PREPARE_BE);
export const virAuth = createAction(types.ATHENA_VIR_AUTH);
export const userVir = createAction(types.ATHENA_VIR_USER);
export const serviceTrackingVir = createAction(types.ATHENA_VIR_SERVICETRACKING);
export const detailVir = createAction(types.ATHENA_VIR_DETAIL);
export const theftVir = createAction(types.ATHENA_VIR_THEFT);
export const detailPatchVir = createAction(types.ATHENA_VIR_DETAIL_PATCH);
// export const initVir = createAction(types.ATHENA_VIR_INTIALIZE);
export const createVir = createAction(types.ATHENA_VIR_CREATE);
export const damagePresigned = createAction(types.ATHENA_DAMAGE_PRESIGNED);
export const searchAddress = createAction(types.SEARCHADDRESS);
export const retrieveAddress = createAction(types.RETRIEVEADDRESS);
export const damagePhotoZip = createAction(types.ATHENA_DAMAGE_PHOTO_ZIP);
export const virLogout = createAction(types.ATHENA_LOGOUT);
export const extendSession = createAction(types.ATHENA_EXTEND_SESSION);
export const deleteVir = createAction(types.ATHENA_VIR_DELETE);
export const resubmitVir = createAction(types.ATHENA_VIR_RESUBMIT);
export const virclean = createAction(types.ATHENA_VIR_CLEAN);
export const virSelectedType = createAction(types.ATHENA_SELECTED_TYPE);
export const virSelectedId = createAction(types.ATHENA_SELECTED_ID);
export const virAppLoading = createAction(types.ATHENA_APP_LOADING);
export const virSource = createAction(types.ATHENA_SOURCE);
export const virReportType = createAction(types.ATHENA_REPORT_TYPE);
export const virRole = createAction(types.ATHENA_ROLE);
export const virCleanUpPhotos = createAction(types.ATHENA_PHOTOS_CLEANUP);
export const virInitAppAndSms = createAction(types.ATHENA_INIT_APP_SMS);
export const virSendContact = createAction(types.VIR_SEND_CONTACT);
export const virResetSendContactForm = createAction(types.VIR_RESET_CONTACT);
